module.exports = __webpack_public_path__ + "img/logo-min.c558edcb.jpg";